import React from "react"
import styled from "styled-components"

export default function QABackground({ className }) {
  return (
    <Wrapper className={className}>
      <Textline className="t1">
        0101010101010101010101010010101010111010101
      </Textline>
      <Textline className="t2">
        01101011101010111010101010000101010000001010
      </Textline>
      <Textline className="t3">
        10101000101010KRYPTOGOKRYPTOGOKRYPTOGOKRYPTOGO
      </Textline>
      <Textline className="t4">
        010001010111KRYPTOGO1101101001001000101110111
      </Textline>
      <Textline className="t5">
        01101011101010111010101010000101010000001010
      </Textline>
      <Textline className="t6">
        01101011101010111010101010000101010000001010
      </Textline>
      <Textline className="t7">
        01101011101010111010101010000101010000001010
      </Textline>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  transition: 1s;
  .box {
    width: 100px;
    height: 100px;
    background-color: #fff;
  }
  &.active {
    opacity: 0;
    transform: scale(0.1);
  }
`

const Textline = styled.div`
  position: absolute;
  overflow: hidden;
  display: inline-block;
  will-change: transform;
  background: linear-gradient(to left, #00fbfffd 0%, rgba(0, 0, 0, 0) 50%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* background-position: 100%; */
  background-size: 200%;
  transform: rotate(90deg);
  animation: textRotate 3s infinite linear;
  font-weight: 700;
  font-size: 24px;

  @keyframes textRotate {
    0% {
      background-position: 0%;
      transform: rotate(90deg) translate(0, 0);
    }
    100% {
      background-position: -200%;
      transform: rotate(90deg) translate(50px, 0);
    }
  }
  &.t1 {
    top: 60%;
    left: -20%;
    animation-delay: 1.5s;
    scale: 1.3;
    animation-timing-function: ease-out;
    animation-duration: 8s;
  }
  &.t2 {
    top: 50%;
    left: 30%;
    animation-delay: 0.5s;
    opacity: 0.1;
    animation-duration: 3s;
  }
  &.t3 {
    top: 80%;
    right: 0;
    animation-delay: 0.5s;
    animation-duration: 5s;
    opacity: 0.1;
    scale: 2;
  }
  &.t4 {
    top: 50%;
    right: -20%;
    animation-delay: 1s;
    animation-duration: 5s;
    scale: 1;
    opacity: 0.5;
  }
  &.t5 {
    top: 50%;
    left: 0%;
    animation-delay: 2s;
    animation-duration: 5s;
    scale: 1;
    opacity: 0.5;
  }
  &.t6 {
    top: 10%;
    right: 10%;
    animation-delay: 1.5s;
    animation-duration: 5s;
    scale: 1;
    opacity: 0.1;
  }
  &.t7 {
    top: 50%;
    right: 35%;
    animation-delay: 0.5s;
    animation-duration: 3s;
    scale: 3;
    opacity: 0.1;
  }

  @media (max-width: 768px) {
    &.t1 {
      top: -20%;
      position: absolute;
      left: 50px;
      animation-delay: 1.5s;
      scale: 1.3;
      opacity: 0.4;
      animation-timing-function: ease-out;
      animation-duration: 8s;
    }
    &.t2 {
      top: 30%;
      left: 10%;
      animation-delay: 0.5s;
      opacity: 0.1;
      animation-duration: 3s;
    }
    &.t3 {
      top: 80%;
      right: 0;
      animation-delay: 0.5s;
      animation-duration: 5s;
      opacity: 0.1;
      scale: 2;
    }
    &.t4 {
      top: 50%;
      right: -14%;
      animation-delay: 1s;
      animation-duration: 5s;
      scale: 1;
      opacity: 0.5;
    }
    &.t5 {
      top: 50%;
      left: 0%;
      animation-delay: 2s;
      animation-duration: 5s;
      scale: 1;
      opacity: 0.5;
    }
    &.t6 {
      top: 10%;
      right: -29%;
      animation-delay: 1.5s;
      animation-duration: 5s;
      scale: 1;
      opacity: 0.1;
    }
    &.t7 {
      top: 50%;
      right: 0%;
      animation-delay: 0.5s;
      animation-duration: 3s;
      scale: 3;
      opacity: 0.1;
    }
  }
`
